class DagiProductStickyAtc extends HTMLElement {
  connectedCallback() {
    this.bar = this.querySelector('[data-sticky-bar]');
    this.trigger = document.querySelector('.dagi-product-buy__submit');
    this.mediaQuery = window.matchMedia('(max-width: 749px)');

    if (!this.bar || !this.trigger) return;

    this.#bindAtc();
    this.#setupObservers();
    this.mediaQuery.addEventListener('change', () => this.#setupObservers());
  }

  disconnectedCallback() {
    this.submitObserver?.disconnect();
    this.footerObserver?.disconnect();
  }

  #bindAtc() {
    this.querySelector('[data-sticky-atc-btn]')?.addEventListener('click', () => {
      if (this.trigger && !this.trigger.disabled) {
        this.trigger.click();
      }
    });
  }

  #setupObservers() {
    this.submitObserver?.disconnect();
    this.footerObserver?.disconnect();

    if (!this.mediaQuery.matches) {
      this.bar.classList.remove('is-visible');
      return;
    }

    this.submitObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.bar.classList.toggle('is-visible', scrolledPast);
        });
      },
      { threshold: 0 }
    );
    this.submitObserver.observe(this.trigger);

    const footer = document.querySelector('.dagi-footer, footer');
    if (!footer) return;

    this.footerObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.bar.classList.toggle('is-hidden-footer', entry.isIntersecting);
        });
      },
      { threshold: 0.05 }
    );
    this.footerObserver.observe(footer);
  }
}

if (!customElements.get('dagi-product-sticky-atc')) {
  customElements.define('dagi-product-sticky-atc', DagiProductStickyAtc);
}
